<template>
    <div>
      <el-drawer @reload="$reloadHandle"
                 :title="'结算申请批量通知'" size="30%"
                 :before-close="handleClose"
                 :visible.sync="visiable"
                 direction="rtl"
                 :modal-append-to-body="true"
                 custom-class="demo-drawer"
                 ref="drawer"
      >
  
        <div class="demo-drawer__content">
          <el-form :model="formData" >
            <span v-if="formData.type=='通知'">您确定批量通知操作吗？</span>
  <!--          <el-form-item label="质检结果" :rules="{required: true}">-->
  <!--            <dict-select dict-type="图片质检结果"-->
  <!--                         :dict-item-id.sync="formData.dictId"-->
  <!--                         :dict-item-name.sync="formData.dictName"-->
  <!--            />-->
  <!--          </el-form-item>-->
            <!-- <el-form-item v-else label="质检不通过原因" :rules="{required: true}">
              <el-input type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        v-model="formData.remark"
                        autocomplete="off"></el-input>
            </el-form-item> -->
          </el-form>
  
          <div class="demo-drawer__footer" style="position: absolute;bottom: 5px;right: 5px;">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary" @click="close"> 确 定 </el-button>
          </div>
        </div>
      </el-drawer>
  
    </div>
  </template>
  <script>
  import api from "@/api/projectApi";
  import DictSelect from "@/components/formItem/dictSelect.vue";
  
  export default {
    name: 'picCheckDialog',
    components: {DictSelect},
    props: ['visiable', 'multi', 'param'],
    created() {
      if (this.param) {
        this.$objCopy(this.param, this.formData)
      }
      console.log('sdfk00000000000000sdkfsd', this.formData, this.param)
    },
    data() {
      return {
        formData: {
          dictId: null,
          dictName: null,
          idList: null,
          type: null
        },
        drawer: true,
      }
    },
    methods: {
      // 关闭
      close() {
        this.$http({
        url: api.sfBatchSettle.batchNoticUrl,
        method: 'post',
        data: this.formData
        }).then(res => {
        this.$message.success('操作成功')
        this.cancelForm()
        this.$emit('goBackIndex')
        })
      },
  
  
  
  
      confirm() {
        this.drawer = false;
        this.handleClose()
      },
      cancelForm() {
        this.visiable = false
        this.$emit('update:visiable', this.visiable)
      },
      handleClose() {
        this.cancelForm()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }
  
  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }
  
  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }
  
  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }
  
  .btn {
    text-align: center;
  }
  </style>
  